var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVitalsWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 17.001V13.251H1.5V5.75098H5.25V2.00098H12.75V5.75098H16.5V13.251H12.75V17.001H5.25ZM3 8.75098H6.75C6.875 8.75098 6.99375 8.78223 7.10625 8.84473C7.21875 8.90723 7.30625 8.98848 7.36875 9.08848L8.025 10.0635L9.0375 7.02598C9.0875 6.87598 9.17812 6.75098 9.30937 6.65098C9.44062 6.55098 9.5875 6.50098 9.75 6.50098C9.875 6.50098 9.99375 6.53223 10.1062 6.59473C10.2187 6.65723 10.3062 6.73848 10.3687 6.83848L11.6437 8.75098H15V7.25098H11.25V3.50098H6.75V7.25098H3V8.75098ZM6.75 15.501H11.25V11.751H15V10.251H11.25C11.125 10.251 11.0062 10.2197 10.8937 10.1572C10.7812 10.0947 10.6875 10.0135 10.6125 9.91348L9.975 8.93848L8.9625 11.976C8.9125 12.126 8.81875 12.251 8.68125 12.351C8.54375 12.451 8.39375 12.501 8.23125 12.501C8.10625 12.501 7.9875 12.4697 7.875 12.4072C7.7625 12.3447 7.675 12.2635 7.6125 12.1635L6.3375 10.251H3V11.751H6.75V15.501Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVitalsWhite);
export default __webpack_public_path__ + "static/media/vitalsWhite.e77ff73e4f1c3b2c5081ad12a67b1870.svg";
export { ForwardRef as ReactComponent };